import { createReducer } from 'helpers/reducers-helper';
import { useReducer } from 'react';
import merge from 'lodash/merge';
import createUseContext from 'constate';
import { useAppContext } from 'use-app';
import get from 'lodash/get';

export const EMAIL_EDIT_MODE = 'email';
export const CHANGE_PASSWORD_EDIT_MODE = 'change_password';
export const TWOFA_MODE = 'twofa';

export const OPEN_IN_EDIT_MODE = 'OPEN_IN_EDIT_MODE';
export const CLOSE_IN_EDIT_MODE = 'CLOSE_IN_EDIT_MODE';

const useProfile = () => {
  const { state: appState } = useAppContext();
  const { me } = appState;
  const subAccount = get(appState, 'me.subAccount', null);
  const isMainAccount = subAccount === null;
  const initState = {
    whichInEditMode: null,
  };

  const openInEditMode = (state, which) => {
    return merge({}, state, { whichInEditMode: which });
  };
  const closeInEditMode = state => {
    return merge({}, state, { whichInEditMode: null });
  };

  const reducer = createReducer(
    {
      [OPEN_IN_EDIT_MODE]: openInEditMode,
      [CLOSE_IN_EDIT_MODE]: closeInEditMode,
    },
    initState
  );

  const [state, dispatch] = useReducer(reducer, initState);

  return { state, dispatch, isMainAccount, me };
};

export const useProfileContext = createUseContext(useProfile);
